const IDC = {
	getIDCData: state => state.IDC || {},
};

export default IDC;
